module.exports = __webpack_public_path__ + "media/packs/images/flags/SV-e1f50484c5300162c5ffafbd5a369b7f.png";